module.exports = __webpack_public_path__ + "static/img/model-bg2.34b3d42.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg2.jpg
// module id = 3GTx
// module chunks = 0